import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import WgptTasks from './Index.vue';
import TaskEditor from './edit/TaskEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-tasks'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'wgpt_tasks',
          redirect: 'list',
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'list',
          name: 'wgpt_tasks_list',
          component: WgptTasks,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-tasks/:taskId/edit'),
      name: 'wgpt_tasks_editor',
      meta: {
        permissions: ['administrator'],
      },
      component: TaskEditor,
    },
  ],
};
